/**
 * Single source of truth for Grade R browseable preset worksheet inventory.
 * Worksheet builder preset arrays derive lengths from these values so counts stay accurate.
 */

export const GRADE_R_COLORING_PRESET_COUNT = 27;

export const GRADE_R_COUNTING_PRESET_COUNT = 16;

export const GRADE_R_MATCHING_PRESET_COUNT = 6;

export const GRADE_R_POEM_ASSET_KEYS = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "9",
] as const;

export const GRADE_R_POEMS_PRESET_COUNT = GRADE_R_POEM_ASSET_KEYS.length;

export const GRADE_R_TRACING_ASSETS = [
  { key: "action", title: "Action Words" },
  { key: "an", title: "AN Family Words" },
  { key: "animals", title: "Animal Words" },
  { key: "at", title: "AT Family Words" },
  { key: "food", title: "Food Words" },
  { key: "ot", title: "OT Family Words" },
  { key: "ow", title: "OW Family Words" },
  { key: "things", title: "Everyday Things" },
] as const;

/** Alphabet overview worksheet + Letter A–Z */
export const GRADE_R_ABC_LETTERS =
  "abcdefghijklmnopqrstuvwxyz".split("") as readonly string[];

/** Additional curated ABC assets present in folder */
export const GRADE_R_ABC_EXTRA_ASSETS = [
  { key: "01", title: "Alphabet Worksheet 01" },
  { key: "Z1", title: "Alphabet Worksheet Z1" },
  { key: "Z2", title: "Alphabet Worksheet Z2" },
] as const;

export const GRADE_R_ABC_PRESET_COUNT =
  1 + GRADE_R_ABC_LETTERS.length + GRADE_R_ABC_EXTRA_ASSETS.length;

export function getGradeRTotalPresetWorksheetCount(): number {
  return (
    GRADE_R_COLORING_PRESET_COUNT +
    GRADE_R_COUNTING_PRESET_COUNT +
    GRADE_R_MATCHING_PRESET_COUNT +
    GRADE_R_POEMS_PRESET_COUNT +
    GRADE_R_TRACING_ASSETS.length +
    GRADE_R_ABC_PRESET_COUNT
  );
}
